import { makeStyles } from '@rbx/ui';

const useCloudIABannerStyles = makeStyles<{ enableNewLayout: boolean }>()(
  (theme, { enableNewLayout }) => ({
    main: {
      ...(enableNewLayout && { justifyContent: 'center' }),
      padding: '12px 30px',
      width: '100%',
    },
    alert: {
      width: '100%',
      maxWidth: 'min(100%, 1212px)',
    },
    alertText: {
      marginTop: '4px',
      [theme.breakpoints.down('Medium')]: {
        display: 'none',
      },
    },
    alertTitle: {
      [theme.breakpoints.down('Medium')]: {
        display: 'none',
      },
    },
    alertTextMobile: {
      display: 'none',
      marginTop: '4px',
      [theme.breakpoints.down('Medium')]: {
        display: 'block',
      },
    },
    optOutButton: {
      minWidth: '75px',
      padding: 0,
    },
    redirectPath: {
      padding: '0px 2px',
      borderRadius: '2px',
      border: `1px solid ${theme.palette.components.divider}`,
      background: theme.palette.surface[100],
    },
  }),
);

export default useCloudIABannerStyles;
